import netsCallDetails from './nets-call-details';
import moduleConfig from './module-config';

export default angular
  .module('app.callDetails', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsCallDetails', netsCallDetails);
